import { IBrand, UnitType } from '@boma/shared/entities';

export interface IProduct {
  id: string;
  brand: IBrand;
  barcode: string;
  active: boolean;
  allowOnline: boolean;
  productMeasurement: UnitType;
  localeMetadata: ILocalMetadata[];
  images: IProductImage[];
  taxDefinitions: IProductTaxDefinition[];
  categories: ICategory[];
}

export interface IProductTaxDefinition {
  rate: number;
  country: ICountry;
}

export interface ILocalMetadata {
  id: string;
  key: string;
  value: string;
  locale: string;
}

interface IProductImage {
  id: string;
  url: string;
  sizes: IProductImageSize[];
}

interface IProductImageSize {
  url: string;
  height: number;
}

interface ICategory {
  id: string;
  name: string;
}

interface ICountry {
  id: string;
  name: string;
}
